<template>
  <div style="padding-bottom: 15px;">
    <FormItem :label="label" :required="required" :value="desc.length + '/' + maxlength" :border="border" />
    <van-field
      v-model="desc"
      rows="3"
      type="textarea"
      clearable
      :maxlength="maxlength"
      :placeholder="placeholder"
      @update:model-value="handleUpdate"
    />
  </div>
</template>

<script setup>
import { useVModel } from "@vueuse/core";
import FormItem from "./FormItem.vue";

const props = defineProps({
  label: { default: "备注" },
  placeholder: { default: "请输入" },
  maxlength: { default: 200 },
  required: { default: false },
  modelValue: { default: "" },
  border: {
    type: Boolean,
    default: true
  }
});

const emit = defineEmits(["update:modelValue", "change"]);

const desc = useVModel(props, "modelValue", emit);

const handleUpdate = val => emit("change", val);
</script>
<style lang="less" scoped>
/deep/.van-field {
  padding: 0;
  font-size: 16px;
}
</style>
